import {ChangeDetectionStrategy, Component, inject, input, model} from '@angular/core';
import {NgbPagination} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from '@app/_services/global.service';

@Component({
    selector: 'app-table-pager',
    imports: [NgbPagination],
    templateUrl: './table-pager.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {class: 'd-flex justify-content-between p-2'}
})
export class TablePagerComponent {
    protected readonly globalService = inject(GlobalService);

    /** :param total: the number of rows across all pages. */
    readonly total = input.required<number>();
    /** :param page: the current page, starting at 1. */
    readonly page = model(1);
    /** :param pageSize: rows per page; choosing a new size returns to page 1. */
    readonly pageSize = model(this.globalService.pagination[0]);

    protected onPageSize(size: number) {
        this.pageSize.set(size);
        this.page.set(1);
    }
}
